export default __webpack_public_path__ + "static/media/benefit5.e958b120.svg";